import { PublicationProps } from 'ech-components/src/components/Publication';
import { LocaleData } from 'ech-components/src/components/Publication/Publication';
import { ImageInterface } from 'ech-components/src/types';

const publicationService = ({
  node_locale: locale,
  linkedPublicationData,
}: PublicationQueryProps) => {
  if (!linkedPublicationData) return null;

  const {
    publicationDate,
    publicationId,
    format,
    teaserImage,
    localizedContents,
  } = linkedPublicationData;

  if (!localizedContents) return null;

  let localeOrder: (keyof PublicationQueryProps['linkedPublicationData']['localizedContents'])[] =
    [];

  switch (locale) {
    case 'fr':
      localeOrder = ['fr', 'it', 'de', 'en'];
      break;
    case 'it':
      localeOrder = ['it', 'fr', 'de', 'en'];
      break;
    case 'en':
      localeOrder = ['en', 'de', 'fr', 'it'];
      break;
    default:
      localeOrder = ['de', 'fr', 'it', 'en'];
  }

  type LocaleDataItem = SingleLocalizedContent & LocaleData;

  const localeData = localeOrder
    .map((key) => {
      const maybeLocalized = localizedContents[key];
      return maybeLocalized ? { ...maybeLocalized, lang: key as string } : null;
    })
    .filter((maybe): maybe is LocaleDataItem => !!maybe);

  if (localeData.length == 0) return null;

  const { title, bblNumber } = localeData[0];
  const shopLink = bblNumber
    ? `https://www.bundespublikationen.admin.ch/cshop_bbl/b2c/init/(cquery=*${bblNumber}*)/.do${
        ['de', 'fr', 'it'].includes(locale) ? `?language=${locale}` : ''
      }`
    : null;

  const publicationProps: PublicationProps['data'] = {
    publicationDate,
    publicationId,
    format,
    title,
    shopLink,
    teaserImage,
    localeData,
  };

  return publicationProps;
};

export type PublicationQueryProps = {
  node_locale: string;
  linkedPublicationData: {
    publicationDate: string;
    publicationId: string;
    format: string;
    teaserImage: ImageInterface['image'];
    localizedContents: {
      de?: SingleLocalizedContent;
      fr?: SingleLocalizedContent;
      it?: SingleLocalizedContent;
      en?: SingleLocalizedContent;
    };
  };
};

export type SingleLocalizedContent = {
  title: string;
  fileUrl: string;
  bblNumber?: string;
};

export default publicationService;
